import { frontendURL } from '../../../helper/URLHelper';
import FavoritesIndex from './pages/FavoritesIndex.vue';
import FavoriteListShow from './pages/FavoriteListShow.vue';

const FAVORITES_PERMISSIONS = ['administrator', 'agent', 'custom_role'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/favoritos'),
    alias: [frontendURL('accounts/:accountId/favorites')],
    name: 'favoritos_index',
    component: FavoritesIndex,
    meta: { permissions: FAVORITES_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/favoritos/:listId'),
    alias: [frontendURL('accounts/:accountId/favorites/:listId')],
    name: 'favoritos_show',
    component: FavoriteListShow,
    meta: { permissions: FAVORITES_PERMISSIONS },
  },
];
